import styled from 'styled-components';

export const RowIconWrapper = styled.div`
  background: ${({ $bg }) => $bg};
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
